import axios from '@/libs/axios'

export default {
    fetchLogs({ commit, dispatch }, searchParams) {
        // todo fontos get hívásnál hogy a params object key alatt menjenek a keresőparaméterek
        // TODO Dávid ide kell majd betenni az EP-t és akkor elvben mindenhol done, más dolog nincs
        return axios.get('/logs', { params: searchParams })
    },
}
